import { IssueStatus } from '../../trusstor/index.js';
import { nextIssueAction, type IssueMoveTarget } from '../../issue-status/index.js';

/** A one-click status move: the button's label and the status it sets. */
export interface IIssueStatusMove {
  labelKey: string;
  next: IssueStatus;
}

/** What a user's single status control on an issue does: a direct move, the review dialog (a manager on an issue
 *  waiting for review), or nothing (no control is rendered). */
export type IssueStatusAction = IIssueStatusMove | 'review' | null;

/** A move's label follows from where it lands. */
const LABEL_KEYS: Record<IssueMoveTarget, string> = {
  [IssueStatus.COMPLETED]: 'issues.card.complete',
  [IssueStatus.FOR_REVIEW]: 'activities.issueStatus.submitForReview',
  [IssueStatus.PLANNED]: 'activities.issueStatus.undo',
};

/**
 * The issue status control a user gets — the shared transition table (`@d-orca/shared/issue-status`, which the
 * server's contributor rule reads too) with a label on each move. The card and the drawer both read it, so their
 * controls can't drift.
 */
export function issueStatusAction(status: IssueStatus, canManage: boolean): IssueStatusAction {
  const action = nextIssueAction(status, canManage);
  if (action === null || action === 'review') return action;
  return { labelKey: LABEL_KEYS[action], next: action };
}
